import { createSlice } from '@reduxjs/toolkit';

import { getId } from './helpers';

const initialState = {
  positionTemplate: {},
  requestedId: undefined,
  pendingRequests: 0,
  isLoading: false,
  hasError: false,
};

const getRequestedId = (requestData) =>
  requestData?.filters?.find((filter) => filter.field === '_id')?.value;

const isRequestedDocument = (state, document) =>
  !!document && getId(document) === state.requestedId;

const isRequestedTemplateLoaded = (state) =>
  !!state.requestedId && getId(state.positionTemplate) === state.requestedId;

const settleRequest = (state, document) => {
  /* eslint-disable no-param-reassign */
  state.pendingRequests = Math.max(state.pendingRequests - 1, 0);
  if (!state.requestedId) return;
  if (isRequestedDocument(state, document)) {
    state.isLoading = false;
    state.hasError = false;
    state.positionTemplate = document;
  } else if (state.pendingRequests === 0 && !isRequestedTemplateLoaded(state)) {
    state.isLoading = false;
    state.hasError = true;
    state.positionTemplate = {};
  }
  /* eslint-enable no-param-reassign */
};

export const positionTemplateDetailSlice = createSlice({
  name: 'positionTemplateDetailSlice',
  initialState,
  reducers: {
    /* eslint-disable no-param-reassign */
    getPositionTemplateDetail: (state, action) => {
      state.requestedId = getRequestedId(action.payload);
      state.pendingRequests += 1;
      state.isLoading = true;
      state.hasError = false;
    },
    getPositionTemplateDetailProcessed: (state, action) => {
      settleRequest(state, action.payload?.data?.documents?.[0]);
    },
    getPositionTemplateDetailError: (state) => {
      settleRequest(state);
    },
    patchPositionTemplateDetail: (state, action) => {
      state.positionTemplate = { ...state.positionTemplate, ...action.payload };
    },
    clearPositionTemplateDetail: (state) => ({
      ...initialState,
      pendingRequests: state.pendingRequests,
    }),
    /* eslint-enable no-param-reassign */
  },
});

export const positionTemplateDetailReducer = positionTemplateDetailSlice.reducer;

export const {
  getPositionTemplateDetail,
  getPositionTemplateDetailProcessed,
  getPositionTemplateDetailError,
  patchPositionTemplateDetail,
  clearPositionTemplateDetail,
} = positionTemplateDetailSlice.actions;
